const whatsappLink = whatsapp => `https://wa.me/${whatsapp.replace(/\D/g, '')}`;

const telegramLink = telegram => `https://t.me/${telegram.replace(/\s/g, '')}`;

const messengerLink = messenger => `https://m.me/${messenger.replace(/\s/g, '')}`;

const maxLink = max => {
  const value = max.replace(/\s/g, '');
  if (/^https?:\/\//i.test(value)) return value;

  return `https://max.ru/${value.replace(/^\/+/, '')}`;
};

export { whatsappLink, telegramLink, messengerLink, maxLink };
